import React from 'react';
import PropTypes from 'prop-types';
import { Input, Select, Row, Col } from 'antd';
import styled from 'styled-components';
import { CustomSelect } from '@4beefopag/4bee-fopag-core/dist/atoms';

const { Search } = Input;

const BarWrapper = styled(Row)`
  margin-bottom: 24px;
`;

function ReportFiltersBar({
  searchPlaceholder,
  searchValue,
  onSearchChange,
  reportTypePlaceholder,
  reportTypes,
  reportTypeValue,
  onReportTypeChange,
}) {
  return (
    <BarWrapper gutter={[16, 16]}>
      <Col
        xs={24}
        sm={24}
        md={8}
        lg={8}
      >
        <Search
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          allowClear
          onSearch={onSearchChange}
        />
      </Col>
      <Col
        xs={24}
        sm={24}
        md={6}
        lg={6}
      >
        <CustomSelect
          style={{ width: '100%' }}
          placeholder={reportTypePlaceholder}
          value={reportTypeValue || undefined}
          onChange={onReportTypeChange}
          allowClear
        >
          {reportTypes.map((opt) => (
            <Select.Option
              key={opt.value}
              value={opt.value}
            >
              {opt.label}
            </Select.Option>
          ))}
        </CustomSelect>
      </Col>
    </BarWrapper>
  );
}

ReportFiltersBar.propTypes = {
  searchPlaceholder: PropTypes.string.isRequired,
  searchValue: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  reportTypePlaceholder: PropTypes.string.isRequired,
  reportTypes: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  reportTypeValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onReportTypeChange: PropTypes.func.isRequired,
};

ReportFiltersBar.defaultProps = {
  reportTypes: [],
  reportTypeValue: undefined,
};

export default ReportFiltersBar;
